module.exports = __webpack_public_path__ + "img/AT0000002571253.4ad1eb69.png";